import { render } from "./social-share-buttons.vue?vue&type=template&id=2a01ef87&scoped=true"
import script from "./social-share-buttons.vue?vue&type=script&lang=js"
export * from "./social-share-buttons.vue?vue&type=script&lang=js"

import "./social-share-buttons.vue?vue&type=style&index=0&id=2a01ef87&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a01ef87"]])

export default __exports__